import React from 'react';
import { Snackbar, Alert } from '@mui/material';

const Toast = ({ open, message, severity, onClose }) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={4000}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      sx={{
        '& .MuiAlert-root': {
          width: '100%',
          boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
          borderRadius: 2,
        }
      }}
    >
      <Alert 
        onClose={onClose} 
        severity={severity} 
        variant="filled"
        sx={{ 
          width: '100%',
          alignItems: 'center',
          '& .MuiAlert-message': {
            fontSize: '0.95rem',
            fontWeight: 500,
          },
          '& .MuiAlert-icon': {
            fontSize: '1.5rem',
          }
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default Toast;